import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const BarChart = ({ data, categories, colors, title, className }) => {
    const chartRef = useRef(null);
  
    useEffect(() => {
      const chartInstance = echarts.init(chartRef.current);
      
      // Remove the sorting of data and categories
      const chartData = [...data];
      const chartCategories = [...categories];

      function hexToRgb(hex) {
        const match = hex.match(/^#([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
        return match ? [
          parseInt(match[1], 16),
          parseInt(match[2], 16),
          parseInt(match[3], 16),
        ] : null;
      }
      
      function getLuminance(rgb) {
        const [r, g, b] = rgb;
        const a = [r, g, b].map((x) => x / 255).map((x) => (x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4)));
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
      }
      
      // Keep colors in their original order to match data
      const chartColors = [...colors];
  
      const options = {
        title: {
          text: title || '',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: '10%',
          left: '-22%',
          right: '10%',
          bottom: '13%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            formatter: (value) => {
              if (value >= 1000) {
                return `${value / 1000}k`;
              }
              return value;
            },
          },
        },
        yAxis: {
          show: false,    
          type: 'category',
          data: chartCategories,
        },
        series: [
          {
            name: 'Order',
            type: 'bar',
            top: 10,
            left: 10,
            right: 10,
            bottom: 20,
            data: chartData,
            avoidLabelOverlap: false,
            itemStyle: {
              color: (params) => chartColors[params.dataIndex],
              borderRadius: [0, 4, 4, 0],
            },
            barWidth: '60%',
          },
        ],
      };
  
      chartInstance.setOption(options);
  
      return () => {
        chartInstance.dispose();
      };
    }, [data, categories, colors, title, className]);

  return (
    <div
      ref={chartRef}
      className={`arcm-bar-chart ${className || 'arcm-h-[170px] arcm-w-[320px]'}`}
    ></div>
  );
};

export default BarChart;